import map from 'ramda/src/map';
import join from 'ramda/src/join';
export default (function (points) {
  return "M".concat(join(' ', map(join(','), points)));
});
//# sourceMappingURL=toPath.js.map